(function () {
  const form = document.querySelector('.custom-contact__form');
  if (!form) return;

  const navigationKeys = new Set([
    'Backspace',
    'Delete',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End',
    'Enter'
  ]);

  /**
   * @param {KeyboardEvent} event
   */
  function isNavigationEvent(event) {
    return navigationKeys.has(event.key) || event.ctrlKey || event.metaKey || event.altKey;
  }

  form.querySelectorAll('[data-custom-contact-name]').forEach(function (input) {
    input.addEventListener('keydown', function (event) {
      if (!(event instanceof KeyboardEvent)) return;
      if (isNavigationEvent(event)) return;
      if (event.key.length === 1 && /[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    });

    input.addEventListener('beforeinput', function (event) {
      if (!(event instanceof InputEvent)) return;
      if (event.inputType === 'insertFromPaste' && event.data && /[0-9]/.test(event.data)) {
        event.preventDefault();
      }
    });
  });

  const phoneInput = form.querySelector('[data-custom-contact-phone]');
  if (!phoneInput) return;

  phoneInput.addEventListener('keydown', function (event) {
    if (!(event instanceof KeyboardEvent)) return;
    if (isNavigationEvent(event)) return;
    if (event.key.length === 1 && /[^\d+\s\-().]/.test(event.key)) {
      event.preventDefault();
    }
  });

  phoneInput.addEventListener('beforeinput', function (event) {
    if (!(event instanceof InputEvent)) return;
    if (event.inputType === 'insertFromPaste' && event.data && /[^\d+\s\-().]/.test(event.data)) {
      event.preventDefault();
    }
  });
})();
